import Button from '@discover-ui/button';
import CloseIcon from '@discover-ui/icons/close.svg';
import { cn } from '@discover-lib/utils';

export default function DismissButton({
  label,
  onClick,
  className,
}: {
  label: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <Button
      kind="white"
      round
      scale="sm"
      width="square"
      type="button"
      aria-label={label}
      className={cn('absolute right-2 top-2 z-10', className)}
      onClick={onClick}>
      <CloseIcon className="text-ds-gray-light-500 size-4" aria-hidden="true" />
    </Button>
  );
}
